import React from 'react';
import { Input, Select, Textarea, DatePicker, Dynamic } from '../Components/';


export default function genInput(item) {
  switch (item.type) {
    case 'select':
      return (
        <Select
          {...item}
          ref={(r) => { this[`$$${item.key}`] = r; }}
          onChange={(e) => {
            if (item.change) {
              const doms = item.changeParams.map(key => this[`$$wrap-${key}`]);
              item.change(e.target.value, ...doms);
            }
          }}
        />
      );
    case 'textarea':
      return (
        <Textarea
          {...item}
          ref={(r) => { this[`$$${item.key}`] = r; }}
        />
      );
    case 'date':
      return (
        <DatePicker
          {...item}
          ref={(r) => { this[`$$${item.key}`] = r; }}
        />
      );
    case 'dynamic':
      return (
        <Dynamic
          {...item}
          ref={(r) => { this[`$$${item.key}`] = r; }}
        />
      );
    default:
      if (item.type === 'number') {
        item.maxLengthShow = false;
      }
      return (
        <Input
          {...item}
          ref={(r) => { this[`$$${item.key}`] = r; }}
        />
      );
  }
}



// WEBPACK FOOTER //
// ./src/Parts/factory.js